import RoomsTable from "./rooms-table";

const Rooms = () => {
  return (
    <div className="content-area">
      <RoomsTable />
    </div>
  );
};

export default Rooms;
